import { api } from '@/lib/api';

export const appointmentsService = {
  async getAll() {
    const { data } = await api.get('/appointments');
    return { data };
  },

  async getById(id) {
    const { data } = await api.get(`/appointments/${id}`);
    return { data };
  },

  async create(appointmentData) {
    const { data } = await api.post('/appointments', appointmentData);
    return { data };
  },

  async update(id, appointmentData) {
    const { data } = await api.patch(`/appointments/${id}`, appointmentData);
    return { data };
  },

  async cancel(id) {
    const { data } = await api.post(`/appointments/${id}/cancel`);
    return { data };
  },
};
